<template>
  <el-container>
    <!---页面头部区域-->
    <el-header style="position: fixed; top: 0px; left: 0px; z-index: 1">
      <!-- 模拟登录提示条 -->
      <div v-if="isImpersonating" style="
        position: fixed;
        top: 6px;
        left: 50%;
        transform: translateX(-50%);
        padding: 4px 24px;
        background: #E6A23C;
        color: #fff;
        line-height: 24px;
        text-align: center;
        font-size: 13px;
        z-index: 100;
        border-radius: 4px;
        white-space: nowrap;
      ">
        当前模拟用户：{{ userName }}
        <el-button type="text" @click="exitImpersonate"
          style="color: #fff; margin-left: 16px; text-decoration: underline;">退出模拟</el-button>
      </div>
      <div class="bg-purple" v-theme.background="mHeader">
        <div style="width:80px; height: 100%">
          <img src="../../static/img/logo.png" class="logoleft" />
          <span class="spanleft" style="margin-left: 5px;">公路工程试验检测资产管理系统</span>
        </div>
        <div class="bg-purple-light" :style="topRightstyle" style="z-index: 10" v-theme.background="mHeader">
          <div class="user__info">
            <div class="user__icon" :style="topRightstyle">
              <el-dropdown @command="handleCommand" class="dropdown">
                <span class="el-dropdown-link" style="color: white; font-size: 15px">
                  {{ userName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">
                    <p @click="uploadPwd()">修改密码</p>
                  </el-dropdown-item>
                  <el-dropdown-item command="b">
                    <p @click="logout">退出登录</p>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <img src="../../static/img/logo.png" style="
                  width: 40px;
                  float: right;
                  height: 40px;
                  vertical-align: middle;
                  margin-top: 8px;
                " alt="" />
              <el-link class="xiaoxi" style="float: right; color: white" :underline="false" @click="toDaiban()">
                <el-badge :value="this.$root.badgeValue" :hidden="this.$root.badgeValue === 0" class="item">
                  <span class="el-icon-chat-dot-round"></span>
                </el-badge>
              </el-link>

              <el-link style="
                  color: white;
                  margin-top: 17px;
                  margin-right: 35px;
                  float: right;
                  vertical-align: middle;
                " :underline="false" @click="changeTheme()">
                <span class="iconfont icon-wode-genghuanpifu"></span>
              </el-link>
              <el-link style="
                  color: white;
                  margin-top: 20px;
                  margin-right: 35px;
                  float: right;
                  vertical-align: middle;
                " :underline="false" @click="appDownload()" target="_blank">
                <img src="../assets/app.png" style="width: 28px; height: 28px; cursor: pointer" />
              </el-link>
              <div style="
                  color: white;
                  margin-top: 17px;
                  margin-right: 35px;
                  float: right;
                  vertical-align: middle;
                  height: 30px;
                " v-if="
                  userinfo && userinfo.fjqx && userinfo.fjqx.indexOf('7') != -1
                ">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    <img src="../assets/screen.png" style="width: 32px; height: 32px; cursor: pointer" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-link href="#/bigScreen1" target="_blank">设备超市</el-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-link href="#/bigScreen2" target="_blank">设备管理系统</el-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-link href="#/bigScreen3" target="_blank">货架总览</el-link>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>

              <!-- <div class="iconfont iconpifu " @click="" style="width:50px"></div> -->
            </div>
          </div>
        </div>
        <!--导航菜单栏标签页-->
        <div class="" :style="topRightstyle" style="
            height: 30px;
            background: white;
            position: fixed;
            left: 240px;
            top: 60px;
            border-top: 2px solid #f1f1f1;
            z-index: 50;
            border-bottom: 3px solid #f1f1f1;
          ">
          <TagsView></TagsView>
        </div>
      </div>
    </el-header>
    <!--导航菜单栏 :unique-opened只允许展示一个，default-active为默认激活菜单的 index
					   	:default-active="$route.path"-->
    <el-container style="position: fixed" v-theme.background="mTheme">
      <el-aside width="240px" class="aside" v-theme.background="mTheme" :style="navStyle">
        <el-scrollbar>
          <el-menu :default-active="activeIndex" v-theme.background="mTheme" @open="handleOpen" @close="handleClose"
            @select="handleselect" text-color="#fff" active-text-color="#ffffff" unique-opened router>
            <template v-for="(item, index) in $router.options.routes" v-theme.background="mTheme" v-if="!item.hidden">
              <el-submenu :index="index + ''" v-theme.background="mTheme" text-color="#fff" active-text-color="#ffffff"
                v-if="menuid.indexOf(item.id) >= 0" class="menu">
                <template slot="title" v-theme.background="mTheme">
                  <div v-pmouseEvents style="
                      text-align: left;
                      width: 222px;
                      margin-left: -15px;
                      padding-left: 10px;
                    ">
                    <i :class="item.iconCls" style="color: white"></i>
                    <span>{{ item.name }}</span>
                  </div>
                </template>
                <el-menu-item v-for="child in item.children" v-theme.background="mTheme" :index="child.path"
                  :key="child.path" v-if="!child.hidden && menuid.indexOf(child.id) >= 0" @click="clickMenu"
                  v-mouseEvents>
                  <span>{{ child.name }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </el-scrollbar>
      </el-aside>
    </el-container>
    <el-main style="background: #f1f1f1">
      <!--路由页面-->
      <section class="content-container" style="background-color: #f1f1f1">
        <div class="grid-content" :style="mainStyle" style="margin-left: 230px; margin-top: 90px">
          <transition name="fade" mode="out-in">
            <!-- <keep-alive :include="cachedViews"> -->
            <router-view></router-view>
            <!-- </keep-alive> -->
          </transition>
        </div>
      </section>
    </el-main>
    <el-dialog modal-append-to-body title="修改密码" width="40%" :append-to-body="true" :visible.sync="uploadPwdBool"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="120px" class="demo-ruleForm pwdForm">
        <el-form-item label="原始密码" prop="oldPassword">
          <el-input v-model="pwdForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="replacePwd">
          <el-input v-model="pwdForm.replacePwd" show-password></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button style="width: 150px" type="primary" @click="updatePassword" :loading="updateLoading">确认</el-button>
          <el-button style="width: 150px" @click="uploadPwdBool = false" :loading="updateLoading">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 更换主题皮肤 -->
    <el-drawer modal-append-to-body :append-to-body="true" title="选择皮肤" size="500px" :visible.sync="currentBgBool">
      <theme></theme>
    </el-drawer>

    <el-dialog modal-append-to-body title="APP下载" width="360px" :append-to-body="true" :visible.sync="appDown"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div style="text-align: center">
        <div>请扫描下方二维码下载APP</div>
        <img src="../assets/appdown.png" style="width: 250px; height: 250px" />
        <div style="padding-bottom: 20px; text-align: right">
          <el-link :underline="false"
            href="https://www.gsztkj.cn/sbgl_api/upload/apk/2026/06/09/977f4d5f-f8ed-4076-8fe8-b3bb4f9241e6.apk"
            target="_blank">
            下载到电脑
          </el-link>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
import { logout, myTranslate, updatePwdByOldPwd, revertImpersonate } from "../api/api";

import { mapState } from "vuex";
//引入tagsview组件
import tagsview from "../components/tagsview/tagsview.vue";
import TagsView from "../components/TabsView/index.vue";
import Theme from "../components/theme.vue";

export default {
  components: {
    tagsview,
    TagsView,
    Theme,
  },
  computed: {
    //引入vuex中state的变量，可以直接this.xxx调用到
    // ...mapState(["loading"]),
  },
  watch: {
    $route(to, from) {
      this.setCurrentRoute();
      // 路由切换时刷新用户信息，解决切换账号后显示旧用户名/菜单的问题
      this.refreshUserFromStore();
    },
  },
  data() {
    var checkReplacePwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.pwdForm.newPassword) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };
    return {
      collapsed: false, // 折叠导航栏bool
      navStyle: {
        height: "",
      },
      topRightstyle: {
        width: "",
      },
      mainStyle: {
        width: "",
        height: "",
      },
      activeIndex: "/DeviceInfo",
      userName: "",
      userinfo: {},
      isImpersonating: false,
      uploadPwdBool: false,
      updateLoading: false,
      pwdForm: {
        oldPassword: "",
        newPassword: "",
        replacePwd: "",
      },
      pwdRules: {
        oldPassword: [
          { required: true, message: "请输入原始密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        replacePwd: [
          { required: true, validator: checkReplacePwd, trigger: "blur" },
        ],
      },
      currentBgBool: false,
      menuid: [],
      rourters: "",
      i: 0,
      timer: "",
      appDown: false,
    };
  },
  methods: {
    //获取登录账户信息
    getUserData() {
      let userSessionData = JSON.parse(localStorage.getItem("user"));
      this.userName = userSessionData.userName;
      let menuids = userSessionData.role.menuId;
      this.menuid = menuids.split(",");
      // if(userSessionData.skin=="theme"){
      //     this.$store.dispatch('UPDATE_THEME', "#23345e");
      //     this.$store.dispatch('UPDATE_HEADER', "#255F9E");
      // }else{
      //     this.$store.dispatch('UPDATE_THEME', "#0680c7");
      //     this.$store.dispatch('UPDATE_HEADER', "#10a1d2");
      // }
      this.$store.dispatch("UPDATE_THEME", localStorage.getItem("theme"));
      this.$store.dispatch("UPDATE_HEADER", localStorage.getItem("header"));
    },
    // 从 localStorage 刷新当前用户（切换账号后调用）
    refreshUserFromStore() {
      let u = JSON.parse(localStorage.getItem("user"));
      if (u && u.userName !== this.userName) {
        this.userName = u.userName;
        this.menuid = (u.role && u.role.menuId) ? u.role.menuId.split(",") : [];
        this.userinfo = u;
      }
    },
    getWidth() {
      //获取浏览器的宽度，减去顶部左侧导航的宽度，就是定都右侧的宽度了
      this.topRightstyle.width = window.innerWidth - 235 + "px";
    },
    getHeight() {
      // 获取浏览器高度，减去顶部导航栏的值，70该值也可以动态获取
      this.navStyle.height = window.innerHeight - 60 + "px";
    },
    getMainStyle() {
      this.mainStyle.height = window.innerHeight;
      this.mainStyle.width = window.innerWidth - 265 + "px";
    },
    start() {
      // 定义定时器，每30秒查询一遍待办
      this.getBadgeValue(); // 立即执行一次
      this.timer = setInterval(this.getBadgeValue, 30 * 1000);
    },
    // 查找待办
    getBadgeValue() {
      try {
        const userStr = localStorage.getItem("user");
        if (!userStr) {
          console.warn('未找到用户信息');
          return;
        }

        const user = JSON.parse(userStr);
        if (!user || !user.userId) {
          console.warn('用户信息不完整');
          return;
        }

        let _params = {
          userId: user.userId,
        };
        this._doGetBadgeValue(_params);
      } catch (error) {
        console.error('解析用户信息失败:', error);
        this.$root.badgeValue = 0;
      }
    },
    _doGetBadgeValue(_params) {
      let _this = this;
      myTranslate(_params).then((datas) => {
        let { status, data } = datas;
        if (status == 200) {
          if (data != null && Array.isArray(data)) {
            _this.$root.badgeValue = data.length;
          } else {
            _this.$root.badgeValue = 0;
          }
        } else {
          _this.$root.badgeValue = 0;
        }
      }).catch((error) => {
        // 如果是 session 未就绪错误，延迟 1 秒后重试一次
        if (error && error.message === 'SESSION_NOT_READY') {
          console.warn('Session 未就绪，1秒后重试获取待办数量');
          setTimeout(() => {
            _this._doGetBadgeValue(_params);
          }, 1000);
          return;
        }
        console.error('获取待办数量失败:', error);
        _this.$root.badgeValue = 0;
      });
    },
    appDownload() {
      this.appDown = true;
    },
    handleOpen(key, keyPath) {
      // debugger
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleselect: function (a, b) { },
    handleCommand(command) {
      // this.$message('click on item ' + command);
    },
    //点击把菜单的名字传出去
    clickMenu(val) {
      val.$el.style.backgroundColor = "" + localStorage.getItem("header") + "";
    },
    setCurrentRoute() {
      this.activeIndex = this.$route.path; // 通过他就可以监听到当前路由状态并激活当前菜单
    },
    // 修改密码
    uploadPwd() {
      // debugger
      this.uploadPwdBool = true;
    },
    // 到待办页面
    toDaiban() {
      // debugger
      this.$router.push({
        path: "myNeed",
      });
    },
    //退出登录
    logout() {
      this.$confirm("确定退出吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        localStorage.removeItem("token");
        localStorage.removeItem("theme");
        localStorage.removeItem("header");
        localStorage.removeItem("user");
        localStorage.removeItem("impersonating");
        sessionStorage.clear();
        logout().then((datas) => {
          this.$router.push({
            path: "/login",
          });
        });
      });
    },
    updatePassword() {
      let _params = {
        password: this.pwdForm.newPassword,
        oldPassword: this.pwdForm.oldPassword,
        userId: JSON.parse(localStorage.getItem("user")).userId,
      };
      debugger;
      updatePwdByOldPwd(_params).then((datas) => {
        let { status, message } = datas;
        if (status == 200) {
          this.$message({ message: message, type: "success" });
          setTimeout(() => {
            this.uploadPwdBool = false;
            this.$router.push({
              path: "/login",
            });
          }, 1500);
        } else {
          this.$message({ message: message, type: "error" });
        }
      });
    },
    // 退出模拟登录
    exitImpersonate() {
      revertImpersonate().then((datas) => {
        let { status, data, message } = datas;
        if (status == 200) {
          localStorage.setItem("user", JSON.stringify(data));
          localStorage.setItem("token", new Date().getTime());
          localStorage.removeItem("impersonating");
          this.isImpersonating = false;
          this.$message({ message: "已恢复管理员身份", type: "success" });
          location.reload();
        } else {
          // 后端提示"没有模拟登录记录"时，说明本地标记已失效（如后端重启导致 session 丢失）
          // 此时本地状态不可信，直接清理标记并刷新，避免提示条一直卡住、按钮点了没反应
          if (message && message.indexOf("没有模拟登录记录") !== -1) {
            localStorage.removeItem("impersonating");
            this.isImpersonating = false;
            this.$message({ message: "模拟状态已失效，已自动清除", type: "warning" });
            setTimeout(() => location.reload(), 800);
          } else {
            this.$message({ message: message || "退出模拟失败", type: "error" });
          }
        }
      });
    },
    changeTheme() {
      this.currentBgBool = true;
    },
  },
  // 自定义指令设置鼠标移入移出事件
  directives: {
    mouseEvents: {
      bind: function (el, binding) {
        el.onmouseenter = function (e) {
          el.style.backgroundColor = "" + localStorage.getItem("header") + "";
        };
        el.onmouseleave = function (e) {
          // debugger
          if (el._prevClass.indexOf("el-menu-item is-active") != -1) {
            el.style.backgroundColor = "" + localStorage.getItem("header") + "";
          } else {
            el.style.backgroundColor = "" + localStorage.getItem("theme") + "";
          }
        };
        el.onblur = function (e) {
          if (el._prevClass.indexOf("el-menu-item is-active") != -1) {
            el.style.backgroundColor = "" + localStorage.getItem("header") + "";
          } else {
            el.style.backgroundColor = "" + localStorage.getItem("theme") + "";
          }
        };

        el.onclick = function (e) {
          el.style.backgroundColor = "" + localStorage.getItem("header") + "";
        };
      },
      updated: function (el, binding) {
        el.onmouseenter = function (e) {
          el.style.backgroundColor = "" + localStorage.getItem("header") + "";
        };
        el.onmouseleave = function (e) {
          if (el._prevClass.indexOf("el-menu-item is-active") != -1) {
            el.style.backgroundColor = "" + localStorage.getItem("header") + "";
          } else {
            el.style.backgroundColor = "" + localStorage.getItem("theme") + "";
          }
        };
        if (el._prevClass.indexOf("el-menu-item is-active") != -1) {
          el.style.backgroundColor = "" + localStorage.getItem("header") + "";
        }
      },

      // componentUpdated: function (el, binding) {
      // 	// el.onmouseenter=function(e){
      // 	// 	el.style.backgroundColor=""+localStorage.getItem("header")+""
      // 	// }
      // 	// el.onmouseleave=function(e){
      // 	// 	if(el._prevClass.indexOf("el-menu-item is-active")!=-1){
      // 	// 		el.style.backgroundColor=""+localStorage.getItem("header")+""
      // 	// 	}else{
      // 	// 		el.style.backgroundColor=""+localStorage.getItem("theme")+""
      // 	// 	}

      // 	// }
      // 	// if(el._prevClass.indexOf("el-menu-item is-active")!=-1){
      // 	// 	el.style.backgroundColor=""+localStorage.getItem("header")+""
      // 	// }
      // 	el.onblur = function (e) {
      // 		if (el._prevClass.indexOf("el-menu-item is-active") != -1) {
      // 			el.style.backgroundColor = "" + localStorage.getItem("header") + ""
      // 		} else {
      // 			el.style.backgroundColor = "" + localStorage.getItem("theme") + ""
      // 		}
      // 	}
      // },
    },
    pmouseEvents: {
      bind: function (el, binding) {
        el.onmouseenter = function (e) {
          el.style.backgroundColor = "" + localStorage.getItem("header") + "";
        };
        el.onmouseleave = function (e) {
          el.style.backgroundColor = "" + localStorage.getItem("theme") + "";
        };
      },
    },
  },
  created() {
    window.addEventListener("resize", this.getHeight);
    window.addEventListener("resize", this.getWidth);
    window.addEventListener("resize", this.getMainStyle);
    this.getHeight();
    this.getWidth();
    this.start();
    this.getMainStyle();
    this.setCurrentRoute();
    this.getUserData();
    this.userinfo = JSON.parse(localStorage.getItem("user"));
    // 双重校验：标记为 true 且当前用户确实不是管理员，才认为处于模拟登录状态
    // （模拟登录的语义是「管理员 → 其他用户」，管理员身份下不可能是模拟状态）
    // 这样即使 localStorage 有残留标记，管理员登录后也不会误显示模拟提示条
    const impersonatingFlag = localStorage.getItem("impersonating") === "true";
    const isAdmin = this.userinfo && (this.userinfo.userRole == 1 || this.userinfo.userRole === "1");
    this.isImpersonating = impersonatingFlag && !isAdmin;
    // 标记与身份矛盾时（残留数据），顺带清理掉，避免一直误导
    if (impersonatingFlag && isAdmin) {
      localStorage.removeItem("impersonating");
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>
<style scoped>
.aside {
  overflow-y: scroll;
  position: fixed;
  top: 60px;
}

.aside::-webkit-scrollbar-button {
  display: none;
}

.aside::-webkit-scrollbar {
  width: 1px;
  height: 1px;
  color: whitesmoke;
}

.bg-purple {
  /* border: 1px solid black; */
  width: 240px;
  background: #255f9e;
  height: 60px;
  /* margin-left: -2px !important; */
  position: fixed !important;
  top: 0px !important;
  left: 0px !important;
}

.bg-purple-light {
  /* border: 1px solid black; */
  background: white;
  border-bottom: 1px solid #c3c3c3;
  position: fixed;
  left: 240px;
  top: 0px;
  height: 60px;
}

.logoleft {
  width: 45px;
  height: 45px;
  margin-top: 5px;
  vertical-align: middle;
  /* margin-left: -150px;
		margin-top: 10px; */
}

.spanleft {
  position: absolute;
  top: 16px;
  width: 350px;
  z-index: 999;
  margin-top: auto 0;
  color: white;
  font-size: 20px;
  vertical-align: middle;
  text-align: left;
}

/* .el-menu-item.is-active {
	background-color: #255F9E !important;

} */
/* .el-submenu__title:hover,
.el-menu-item:focus,
.el-menu-item:hover {
	background-color: #255F9E !important;
}  */

/* .el-menu-vertical-demo:hover {
	background-color: #255F9E !important;
}  */
/*
 .el-submenu:hover {
	background-color: #3d4e61 !important;
}  */

/*铺满屏幕，没有边距*/
.el-container {
  padding: 0px;
  margin: 0px;
  height: 100wh;
}

.el-header {
  /* 顶部部分的高度(默认60px) */
  /* background-color: #0077d5; */
  color: #ffffff;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
}

.el-submenu__title>i {
  color: white !important;
  margin-left: -120px;
}

.el-menu--inline>li {
  text-align: left;
}

.aside {
  position: absolute;
  left: 0px;
  top: 60px;
  /* background-color: #23345E; */
}

.user__icon {
  width: 150px;
  height: 60px;
}

.user__info {
  color: black;
}

.dropdown {
  position: relative;
  top: 5%;
  margin-top: 16px;
  float: right;
  margin-right: 18px;
  margin-left: 10px;
}

.iconfont {
  font-size: 30px !important;
}

.xiaoxi {
  color: red;
  font-size: 30px;
  vertical-align: middle;
  margin-right: 45px;
  margin-top: 11px;
}

/* .el-link:hover {
	color: white !important;
} */

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #cfcbcb;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue